import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="12" height="13" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M5.68902 8.41282L2.12874 4.74607C1.95709 4.56929 1.95709 4.28251 2.12874 4.10573L2.54405 3.67802C2.71553 3.50143 2.99326 3.50124 3.1651 3.67727L5.99991 6.58331L8.8349 3.67745C9.00674 3.50124 9.28447 3.50162 9.45595 3.67821L9.87126 4.10592C10.0429 4.2827 10.0429 4.56947 9.87126 4.74626L6.3108 8.41282C6.13914 8.58961 5.86068 8.58961 5.68902 8.41282Z"
      fill="#CCCCCC"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const GrayArrow = memo(ForwardRef);
export default GrayArrow;
